import { useQuery } from "@tanstack/react-query";
import { Moment, API } from "config";

const usePurchaseClassificationList = ({ page = 1, period, order_by = "approved_at", threshold_min, threshold_max }) => {
    return useQuery({
        queryKey: ["purchaseRating", page, period, order_by, threshold_min, threshold_max],
        queryFn: async () => {
            // Validação simples do período
            if (!period || !Array.isArray(period) || period.length !== 2) {
                throw new Error("Período inválido");
            }

            const [startDate, endDate] = period;

            if (
                !startDate ||
                !endDate ||
                isNaN(new Date(startDate).getTime()) ||
                isNaN(new Date(endDate).getTime())
            ) {
                throw new Error("Datas inválidas no período");
            }

            const startFormatted = Moment(startDate).format("YYYY-MM-DD");
            const endFormatted = Moment(endDate).format("YYYY-MM-DD");

            // Monta a URL da API com query params
            const url = `/reports/purchase-classification?page=${page}` +
                `&period[]=${startFormatted}` +
                `&period[]=${endFormatted}` +
                (order_by ? `&order_by=${order_by}` : "") +
                (threshold_min ? `&threshold_min=${threshold_min}` : "") +
                (threshold_max ? `&threshold_max=${threshold_max}` : "");

            const response = await API.get(url);
            return response?.data;
        },
        keepPreviousData: true,
    });
};

export default usePurchaseClassificationList;
